<template>
  <DashboardContainer>
    <v-card style="border-radius: 10px">
      <v-card-title>Project Invitation</v-card-title>
      <v-card-text>
        You have been invited to the project <strong>{{ name }}</strong
        >. Please accept the invitation.

        <p></p>
        <v-btn
          color="primary"
          :disabled="acceptLoading"
          :loading="acceptLoading"
          @click="acceptInvitation()"
          >Accept</v-btn
        ></v-card-text
      >
    </v-card>
  </DashboardContainer>
</template>

<script>
import DashboardContainer from "../components/DashboardContainer";
import axios from "axios";
import { mapMutations } from "vuex";

export default {
  components: {
    DashboardContainer,
  },
  data() {
    return {
      projectId: this.$route.query.projectId,
      name: this.$route.query.name,
      token: this.$route.query.token,
      acceptLoading: false,
    };
  },
  methods: {
    ...mapMutations(["ALERT_SUCCESS", "ALERT_ERROR"]),
    async acceptInvitation() {
      this.acceptLoading = true;
      const response = await axios.post(
        "/Console/AcceptProjectAssigneeInvitation",
        {
          projectId: this.projectId,
          token: this.token,
        }
      );
      this.acceptLoading = false;
      if (response.data.succeed) {
        this.$router.push("/");
        this.ALERT_SUCCESS("Project invitation accepted!");
      } else {
        this.ALERT_ERROR("Error when accepting invitation");
      }
    },
  },
  async created() {
    document.title = "Project Invitation - Landly Console";
  },
};
</script>